module.exports = __webpack_public_path__ + "static/bsky-797037369541dafc4f905a87c8062202.png";